const REPORT_TYPES = {
  FINAL_REPORT: "FINAL_REPORT",
  MEASUREMENT_PLAN: "MEASUREMENT_PLAN",
  AST: "AST",
  QAL: "QAL2",
  REGULATORY_REPORT: "REGULATORY_REPORT",
  NO_REGULATORY_REPORT: "NO_REGULATORY_REPORT",
  UNANNOUNCED_CONTROL: "UNANNOUNCED_CONTROL",
};

const DATA_EXPORT_TYPES = new Set([REPORT_TYPES.QAL, REPORT_TYPES.AST]);

export { REPORT_TYPES, DATA_EXPORT_TYPES };
